export default "__VITE_ASSET__UCibYv72__"